import React, { useState } from 'react'
import useExperiencePlayerLaunch from 'hooks/useExperiencePlayerLaunch'
import { DEFAULT_TTL_SECONDS } from 'lib/experiencePlayer/constants'
import ExperiencePlayerTestComponent from './component'

const DEFAULT_LESSON_ID = 'test-lesson'

const ExperiencePlayerTestContainer = () => {
  const [lessonIdInput, setLessonIdInput] = useState(DEFAULT_LESSON_ID)
  const [activeLessonId, setActiveLessonId] = useState(DEFAULT_LESSON_ID)
  const [ttlSeconds, setTtlSeconds] = useState(DEFAULT_TTL_SECONDS)
  const [generatePassword, setGeneratePassword] = useState(false)

  const {
    link,
    isCreating,
    isExpired,
    error,
    generateLink,
    timeUntilExpiry,
  } = useExperiencePlayerLaunch({ lessonId: activeLessonId })

  const handleGenerate = () => {
    setActiveLessonId(lessonIdInput)
    generateLink({ lessonId: lessonIdInput, ttlSeconds, generatePassword })
  }

  const handleLessonIdChange = e => setLessonIdInput(e.target.value)
  const handleTtlChange = e => {
    if (typeof e === 'number') {
      setTtlSeconds(Math.max(1, Math.floor(e)))
      return
    }

    const nextValue = Number.parseInt(e.target.value, 10)
    if (Number.isNaN(nextValue)) return

    setTtlSeconds(Math.max(1, nextValue))
  }
  const handleGeneratePasswordChange = e => setGeneratePassword(e.target.checked)

  return (
    <ExperiencePlayerTestComponent
      error={error}
      generatePassword={generatePassword}
      isCreating={isCreating}
      isExpired={isExpired}
      lessonIdInput={lessonIdInput}
      link={link}
      onGenerate={handleGenerate}
      onGeneratePasswordChange={handleGeneratePasswordChange}
      onLessonIdChange={handleLessonIdChange}
      onTtlChange={handleTtlChange}
      timeUntilExpiry={timeUntilExpiry}
      ttlSeconds={ttlSeconds}
    />
  )
}

export default ExperiencePlayerTestContainer
